import React from 'react';
import { useNavigate } from 'react-router-dom';
import SubmitButton from '../../submitButton/SubmitButton';

// Images
import imgMain from '../../../assets/images/2.png';
import imgOverlay1 from '../../../assets/images/3.png';
import imgOverlay2 from '../../../assets/images/4.png';
import imgOverlay3 from '../../../assets/images/5.png';

// Text config
import landingText from './landingText';

const LandingSection = () => {
  const navigate = useNavigate();

  return (
    <div className="px-3 px-lg-0">
      <section className="landingMainSection bg-white p-3 p-lg-5 br_10 mt-2 w-100 mx-auto">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Content */}
            <div className="col-lg-6">
              <h1 className="text-black font_700 BannerHeading mb-2">
                {landingText.heading}{' '}
                <span className="landingSectionHighlightText position-relative">
                  {landingText.highlightedText}
                </span>{' '}
                <br /> AI Solutions
              </h1>
              <p className="font_14 line_height1_7 text_light1">
                Experience intelligent document processing, ID verification, and
                customer engagement with our{' '}
                <span className="text-black font_600">free trial platform</span>
                . No commitment, just results.
              </p>
              <div className="d-flex mt-3 gap-2">
                <SubmitButton
                  className=" rounded-pill py-3"
                  onClick={() => navigate('/products')}
                  // onClick={() =>
                  //   (window.location.href = `${window.baseUrl}/subscription?productKey=${HARDCODED_PRODUCTKEY}`)
                  // }
                  label="Get Started"
                />

                <SubmitButton
                  style={{ marginTop: '0px' }}
                  className="mt-0 rounded-pill btn-master-line"
                  onClick={() => navigate('/sales-query')}
                  label="Talk to Sales"
                />
              </div>
            </div>

            <div className="col-lg-6 order-first order-lg-last">
              <div className="d-flex justify-content-end position-relative">
                {[...Array(4)].map((_, i) => (
                  <div key={i} className="squareIcon" />
                ))}
                <img
                  className="h_550x BannerMainImg"
                  src={imgMain}
                  alt="Main visual"
                />
                <img
                  className="position-absolute increaseImgDesign"
                  src={imgOverlay1}
                  alt="Overlay 1"
                />
                <div className="increaseImgDesign2 d-flex flex-column">
                  <img className="mb-4" src={imgOverlay3} alt="Overlay 2" />
                  <img src={imgOverlay2} alt="Overlay 3" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingSection;
